module.exports = __webpack_public_path__ + "img/Best of Argentinian Rot.881abf87.jpg";